import { FeedAdditiveTypeListDto, ProducerListDto, ProductDto } from './feedRegistry/api/params';

const ACCEPTED_CODE = 1;
const REGISTERED_CODE = 13;
const REGISTRATION_REJECTED_CODE = 17;
const MAKING_CHANGES_CODE = 20;
const CHANGES_MADE_CODE = 28;

export const formatVendor = (product: ProductDto, whithoutCountry?: boolean) => {
  if (product.addressVendor) {
    return [
      product.addressVendor.businessEntity?.name,
      product.addressVendor.address,
      whithoutCountry ? undefined : product.vendorCountry?.name,
    ]
      .filter((el) => el)
      .join(', ');
  }
  return [
    product.vendor,
    product.vendorAddressText,
    whithoutCountry ? undefined : product.vendorCountry?.name,
  ]
    .filter((el) => el)
    .join(', ');
};

export const formatProducer = (product: ProducerListDto, whithoutCountry?: boolean) => {
  if (product.address) {
    return [
      product.address.businessEntity?.name,
      product.address.address,
      whithoutCountry ? undefined : product.country?.name,
    ]
      .filter((el) => el)
      .join(', ');
  }
  return [product.name, product.addressText, whithoutCountry ? undefined : product.country?.name]
    .filter((el) => el)
    .join(', ');
};

export const formatFeedAdditiveTypeList = (
  feedAdditiveTypeList: FeedAdditiveTypeListDto[] | undefined
) => {
  if (!feedAdditiveTypeList || feedAdditiveTypeList.length === 0) {
    return '';
  }
  return feedAdditiveTypeList.map((el) => `${el.code}: ${el.description}`).join(', ');
};

export const getRegistryHeaderColor = (code: number) =>
  code === MAKING_CHANGES_CODE || code === REGISTERED_CODE || code === CHANGES_MADE_CODE
    ? 'blue'
    : 'grey';

export const getRequestsHeaderColor = (code: number) =>
  code === REGISTRATION_REJECTED_CODE ? 'grey' : 'green';

export const getProgressStep = (code?: number) => {
  switch (code) {
    case ACCEPTED_CODE:
      return 1;
    case REGISTRATION_REJECTED_CODE:
      return undefined;
    default:
      return 2;
  }
};
